
import qs from 'qs';

const filterActions = {
    applyFilterGroupCollection: (filterGroupCollection, filterGroupCollectionIndex) => ({
        type: 'APPLY_FILTER_GROUP_COLLECTION',
        payload: {
            filterGroupCollection,
            filterGroupCollectionIndex
        }
    }),
    applyFilterGroupCollectionById: (filterGroupCollection, filterGroupCollectionId) => ({
        type: 'APPLY_FILTER_GROUP_COLLECTION_BY_ID',
        payload: {
            filterGroupCollection,
            filterGroupCollectionId
        }
    }),
    applyFilterGroupCollections: filterGroupCollections => ({
        type: 'APPLY_FILTER_GROUP_COLLECTIONS',
        payload: {
            filterGroupCollections
        }
    }),
    clearAllFilters: () => ({
        type: 'CLEAR_ALL_FILTERS'
    }),
    selectDate: date => ({
        type: 'SELECT_DATE',
        payload: {
            date
        }
    }),
    selectTag: tag => ({
        type: 'SELECT_TAG',
        payload: {
            tag
        }
    }),
    clearTag: () => ({
        type: 'CLEAR_TAG'
    }),
    selectGuests: guests => ({
        type: 'SELECT_GUESTS',
        payload: {
            guests
        }
    }),
    selectLocation: location => ({
        type: 'SELECT_LOCATION',
        payload: {
            location
        }
    }),
    setActiveFilterGroupCollection: filterGroupCollectionIndex => ({
        type: 'SET_ACTIVE_FILTER_GROUP_COLLECTION',
        payload: {
            filterGroupCollectionIndex
        }
    }),
    setArrayFilter: (paramSlug, filterIdArray) => ({
        type: 'SET_ARRAY_FILTER',
        payload: {
            paramSlug,
            filterIdArray
        }
    }),
    setSingularFilter: (paramSlug, filterValue) => ({
        type: 'SET_SINGULAR_FILTER',
        payload: {
            paramSlug,
            filterValue
        }
    }),
    setOtherFilters: params => {
        return dispatch => {
            for (const prop in params) {
                if (params.hasOwnProperty(prop)) {
                    if (Array.isArray(params[prop])) {
                        dispatch(filterActions.setArrayFilter(prop, params[prop]));
                    } else if (prop !== 'currency_symbol') {
                        dispatch(filterActions.setSingularFilter(prop, params[prop]));
                    }
                }
            }
        };
    },
    setFilters: (location, tag, params) => {
        const queryObj = qs.parse(params);
        return dispatch => {
            dispatch(filterActions.selectDate(queryObj.date));
            dispatch(filterActions.selectTag(tag));
            dispatch(filterActions.selectGuests(queryObj.guests));
            dispatch(filterActions.selectLocation(location));
            dispatch(filterActions.setOtherFilters(params));
        };
    },
    setTagLabel: tagLabel => ({
        type: 'SET_TAG_LABEL',
        payload: {
            tagLabel
        }
    }),
    toggleFilterGroupExpansion: (
        filterGroupCollectionIndex,
        filterGroupIndex
    ) => ({
        type: 'TOGGLE_FILTER_GROUP_EXPANSION',
        payload: {
            filterGroupCollectionIndex,
            filterGroupIndex
        }
    }),
    updateSliderText: () => ({
        type: 'UPDATE_SLIDER_TEXT'
    })
};

export default filterActions;



// WEBPACK FOOTER //
// ./src/pages/Search/actions/filterActions.js